import React from 'react';
import { HelpText } from '../common/HelpText';
const Checkbox = ({ id, name, label, checked, onChange, className, color, hideLabel, disabled, type, labelClassName, required, helpText, }) => {
    const renderHelpText = () => {
        return helpText ? React.createElement(HelpText, { className: 'help-text-margin' }, helpText) : null;
    };
    const classNameResult = 'ac-checkbox ' +
        (type === 'radio' ? 'ac-radio ' : '') +
        'ac-checkbox-' +
        color +
        ' ' +
        'ac-control-input ' +
        (hideLabel ? ' hide-label' : '');
    return (React.createElement("div", { title: hideLabel ? label : null, className: 'ac-checkbox-wrapper ' + (className ? className : '') },
        React.createElement("div", { className: 'ac-checkbox-controls' },
            React.createElement("input", { id: id, name: name, type: type ? type : 'checkbox', color: 'success', checked: checked, disabled: disabled, required: required, className: classNameResult, onChange: () => {
                    onChange(!checked);
                } }),
            hideLabel ? ('') : (React.createElement("label", { htmlFor: id, className: 'ml-x2 ac-control-label ' + (disabled ? 'label-disabled ' : '') + (labelClassName ? labelClassName : '') }, label))),
        renderHelpText()));
};
export { Checkbox };
//# sourceMappingURL=Checkbox.js.map